/**
 * Appends catch all to the end of a given route path.
 * This is useful when you want to match all routes that start with a given path.
 */
export function appendCatchAll(routePath: string): string {
    return `${routePath}/*`;
}
